<template>
  <component
    :is="as"
    v-bind="$attrs"
    class="ui-focusable"
    :aria-disabled="disabled || undefined"
    :tabindex="disabled ? undefined : 0"
    @click="activate"
    @keydown.enter.prevent="activate"
    @keydown.space.prevent="activate"
  >
    <slot />
  </component>
</template>

<script setup lang="ts">
  defineOptions({ inheritAttrs: false, name: 'UiFocusable' })
  const props = withDefaults(defineProps<{ as?: string; disabled?: boolean }>(), { as: 'span' })
  const emit = defineEmits<{ press: [event: Event] }>()
  const activate = (event: Event) => {
    if (!props.disabled) emit('press', event)
  }
</script>

<style scoped>
  .ui-focusable:focus-visible {
    outline: 2px solid var(--color-effects-focus-rings-focus-ring);
    outline-offset: 2px;
    border-radius: var(--radius-xs);
  }

  .ui-focusable[aria-disabled="true"] {
    cursor: default;
  }
</style>
